import React from 'react';
import {TimelineItem} from './TimelineItemComponent';
import './styles.scss';

interface TimelineEvent {
  id: string;
  title: string;
  timestamp: string;
}

interface TimelineComponentProps {
  timeline: Array<{
    comment: string;
    created_at: string;
  }>;
}

const TimelineComponent: React.FC<TimelineComponentProps> = ({timeline}) => {
  const timelineEvents: TimelineEvent[] = timeline.map((item, idx) => {
    let timestamp = item.created_at;
    if (timestamp && timestamp.includes(' ')) {
      const [date, time] = timestamp.split(' ');
      timestamp = `${date} - ${time}`;
    }
    return {
      id: String(idx + 1),
      title: item.comment,
      timestamp,
    };
  });

  return (
    <div className="timeline-container">
      <h2 className="timeline-title">Timeline</h2>
      <div className="timeline-events">
        {timelineEvents.map((event, index) => (
          <TimelineItem key={`${event.id}-${index}`} event={event} />
        ))}
      </div>
    </div>
  );
};

export default TimelineComponent;
